import { EntityRepository, Repository } from "typeorm";
import { SaleOrderTrack } from "../so-track.entity";

@EntityRepository(SaleOrderTrack)
export class SoTrackRepository extends Repository<SaleOrderTrack>{


}
